import { asMultiStyleConfig } from '../../../../utils/theme';
export var DetailsCard = asMultiStyleConfig({
  parts: ['container', 'header', 'footer', 'body'],
  defaultProps: {
    colorScheme: 'idle'
  },
  baseStyle: {
    container: {
      boxSizing: 'border-box',
      borderRadius: '10px',
      boxShadow: '0 0 12px -8px rgba(0, 0, 0, 0.35)',
      position: 'relative'
    },
    header: {
      display: 'flex',
      borderTopLeftRadius: 'md',
      borderTopRightRadius: 'md',
      p: {
        base: 5,
        md: 4
      }
    },
    body: {
      pl: {
        base: 5,
        md: 4
      },
      pr: {
        base: 5,
        md: 4
      },
      pb: {
        base: 5,
        md: 4
      }
    },
    footer: {
      px: {
        base: 5,
        md: 4
      },
      py: 4,
      borderBottomLeftRadius: 'md',
      borderBottomRightRadius: 'md'
    }
  },
  colorSchemes: {
    idle: {
      container: {
        backgroundColor: 'white',
        border: '1px solid #EAEAEA'
      },
      footer: {
        bg: '#f8f8f8',
        border: 'grey.200'
      }
    },
    focus: {
      container: {
        bg: '#d3e8ff',
        borderColor: '#57A7DA'
      },
      footer: {
        bg: '#cde2f9'
      }
    },
    success: {
      container: {
        bg: '#F6FFF6',
        borderColor: '#34AA40'
      },
      footer: {
        bg: '#F2FBF2'
      }
    },
    pending: {
      container: {
        bg: '#FFEFD3',
        borderColor: '#F5A623'
      },
      footer: {
        bg: '#F7E7CC'
      }
    }
  }
});